var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"educationIndex"},[_c('h2',{staticClass:"sr-only"},[_vm._v("愛樹教育")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }